import { render } from "./viewform.vue?vue&type=template&id=3a16c42d"
import script from "./viewform.js?vue&type=script&lang=js"
export * from "./viewform.js?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__